import { Color, getDefaultTransition, getShadow, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

import { PANEL_HORIZONTAL_PADDING } from './constants/panelHorizontalPadding'

interface NotesPanelWrapperProps {
  isOpen: boolean
}

export const NotesPanelWrapper = styled.div<NotesPanelWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 366px;
  height: 100vh;
  padding: ${Spacing.S24} ${PANEL_HORIZONTAL_PADDING} 0;
  position: fixed;
  top: 0;
  right: 0;
  z-index: ${zIndex.NotesPanel};
  transform: ${({ isOpen }) => `translateX(${isOpen ? 0 : '100%'})`};
  background-color: ${Color.White};
  will-change: transform;
  ${getShadow('raisedStrong')};
  ${getDefaultTransition('transform')};
`

export const FormWrapper = styled.div``

export const NotesList = styled(SimpleBar)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-right: -${PANEL_HORIZONTAL_PADDING};
  margin-left: -${PANEL_HORIZONTAL_PADDING};
  padding-right: ${PANEL_HORIZONTAL_PADDING};
  padding-left: ${PANEL_HORIZONTAL_PADDING};
  overflow: auto;
  list-style-type: none; /* important when using SimpleBar */
`
